import React, {useCallback, useEffect, useState} from 'react';
import './TextEditor.scss';
import {Color} from '@tiptap/extension-color';
import ListItem from '@tiptap/extension-list-item';
import TextStyle from '@tiptap/extension-text-style';
import {EditorProvider, useCurrentEditor} from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Link from '@tiptap/extension-link';
import UploadImage from 'tiptap-extension-upload-image';
import 'tiptap-extension-upload-image/dist/upload-image.min.css';
import {SketchPicker} from 'react-color';
import axios from 'axios';
import TextCenterIcon from './TextEditorComponents/icons/TextCenterIcon';
import TextJustifyIcon from './TextEditorComponents/icons/TextJustifyIcon';
import ColorPickerIcon from './TextEditorComponents/icons/ColorPickerIcon';
import ImageIcon from './TextEditorComponents/icons/ImageIcon';
import LinkIcon from './TextEditorComponents/icons/LinkIcon';
import PaintBrushIcon from './TextEditorComponents/icons/PaintBrushIcon';
import TextLeftIcon from './TextEditorComponents/icons/TextLeftIcon';
import TextRightIcon from './TextEditorComponents/icons/TextRightIcon';
import TextBoldIcon from './TextEditorComponents/icons/TextBoldIcon';
import TextItalicIcon from './TextEditorComponents/icons/TextItalicIcon';
import StrikeIcon from './TextEditorComponents/icons/StrikeIcon';
import EraserIcon from './TextEditorComponents/icons/EraserIcon';
import BulletListIcon from './TextEditorComponents/icons/BulletListIcon';
import NumberListIcon from './TextEditorComponents/icons/NumberListIcon';
import CodeIcon from './TextEditorComponents/icons/CodeIcon';
import RulerIcon from './TextEditorComponents/icons/RulerIcon';
import UnLinkIcon from './TextEditorComponents/icons/UnLinkIcon';
import SelectArrowIcon from './TextEditorComponents/icons/SelectArrowIcon';
import CreateIcon from './TextEditorComponents/icons/table/Create';
import AddRightIcon from './TextEditorComponents/icons/table/AddRight';
import AddTopIcon from './TextEditorComponents/icons/table/AddTop';
import AddBottomIcon from './TextEditorComponents/icons/table/AddBottom';
import AddLeftIcon from './TextEditorComponents/icons/table/AddLeft';
import RemoveRowIcon from './TextEditorComponents/icons/table/RemoveRow';
import RemoveColumnIcon from './TextEditorComponents/icons/table/RemoveColumn';
import DeleteIcon from './TextEditorComponents/icons/table/Delete';
import MergeIcon from './TextEditorComponents/icons/table/Merge';
import SplitIcon from './TextEditorComponents/icons/table/Split';
import HeaderCellIcon from './TextEditorComponents/icons/table/HeaderCell';
import HeaderColumnIcon from './TextEditorComponents/icons/table/HeaderColumn';
import HeaderRowIcon from './TextEditorComponents/icons/table/HeaderRow';
import CustomSelect from './TextEditorComponents/CustomSelect/CustomSelect';
import CustomDropdown from './TextEditorComponents/CustomDropDown/CustomDropDown';
import UndoIcon from './TextEditorComponents/icons/UndoIcon';
import RedoIcon from './TextEditorComponents/icons/RedoIcon';
import {prefixUrl} from "../../../../utils/utilsData";
import {useLocation, useNavigate} from "react-router-dom";
import _axios from "../../../../httpService";
import Loader from "../../../Loader";
import {toast} from "react-toastify";

const TextEditor = () => {

  const myLocation: Location = useLocation();
  const navigateTo = useNavigate();
  const fixURL = prefixUrl() + '/memoPlusTemporaryUpload/?request=getEditorData&entity=' + myLocation.state?.entity + '&pkValue=' + myLocation.state?.pkValue;
  const fixEntity = myLocation.state?.entity;
  const [isLoad, setIsLoad] = useState(false);
  const [content, setContent] = useState('<p></p>');

  const fontSizes = [
    {label: '8', value: '8px'},
    {label: '9', value: '9px'},
    {label: '10', value: '10px'},
    {label: '11', value: '11px'},
    {label: '12', value: '12px'},
    {label: '14', value: '14px'},
    {label: '16', value: '16px'},
    {label: '18', value: '18px'},
    {label: '20', value: '20px'},
    {label: '22', value: '22px'},
    {label: '24', value: '24px'},
    {label: '26', value: '26px'},
    {label: '28', value: '28px'},
    {label: '36', value: '36px'},
    {label: '48', value: '48px'},
    {label: '72', value: '72px'},
  ];

  const CustomTableCell = TableCell.extend({
    addAttributes() {
      return {
        ...this.parent?.(),

        backgroundColor: {
          default: null,
          parseHTML: (element) =>
            element.getAttribute('data-background-color'),
          renderHTML: (attributes) => {
            return {
              'data-background-color': attributes.backgroundColor,
              style: `background-color: ${attributes.backgroundColor}`,
            };
          },
        },
      };
    },
  });

  const CustomTextStyle = TextStyle.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        fontSize: {
          default: null,
          parseHTML: (element) => element.style.fontSize,
          renderHTML: (attributes) => {
            return {
              style: `font-size: ${attributes.fontSize}`,
            };
          },
        },
      };
    },
  });

  useEffect(() => {
    _axios.get(fixURL).then((response) => {
      if (response.data.status) {
        setIsLoad(true)
        if (response.data?.editorData) {
          setContent(response.data?.editorData)
        } else {
          setContent('<p></p>')
        }
      }
    })
  }, []);

  const MenuBar = () => {
    const {editor} = useCurrentEditor();
    const [showColorPicker, setShowColorPicker] = React.useState(false);
    const [color, setColor] = React.useState('#000000');
    const colorPickerRef = React.useRef(null);

    const elementTag = [
      {
        func: () => editor.chain().focus().setParagraph().run(),
        label: 'بند',
        fontSize: '13px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 1}).run(),
        label: 'عنوان ۱',
        fontSize: '22px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 2}).run(),
        label: 'عنوان ۲',
        fontSize: '20px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 3}).run(),
        label: 'عنوان ۳',
        fontSize: '18px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 4}).run(),
        label: 'عنوان ۴',
        fontSize: '16px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 5}).run(),
        label: 'عنوان ۵',
        fontSize: '14px',
      },
      {
        func: () =>
          editor.chain().focus().toggleHeading({level: 6}).run(),
        label: 'عنوان ۶',
        fontSize: '12px',
      },
    ];

    const dropDownOptions = [
      {
        func: () =>
          editor
            .chain()
            .focus()
            .insertTable({
              rows: 3,
              cols: 3,
              withHeaderRow: false,
            }).run(),
        label: 'ساخت جدول',
        icon: <CreateIcon/>,
      },
      {
        func: () => editor.chain().focus().addColumnBefore().run(),
        label: 'افزودن ستون به چپ',
        icon: <AddLeftIcon/>,
      },
      {
        func: () => editor.chain().focus().addColumnAfter().run(),
        label: 'افزودن ستون به راست',
        icon: <AddRightIcon/>,
      },
      {
        func: () => editor.chain().focus().deleteColumn().run(),
        label: 'پاک کردن ستون',
        icon: <RemoveColumnIcon/>,
      },
      {
        func: () => editor.chain().focus().addRowBefore().run(),
        label: 'فزودن ردیف به بالا',
        icon: <AddTopIcon/>,
      },
      {
        func: () => editor.chain().focus().addRowAfter().run(),
        label: 'فزودن ردیف به پایین',
        icon: <AddBottomIcon/>,
      },
      {
        func: () => editor.chain().focus().deleteRow().run(),
        label: 'پاک کردن ردیف',
        icon: <RemoveRowIcon/>,
      },
      {
        func: () => editor.chain().focus().mergeCells().run(),
        label: 'ترکیب کردن سلول های انتخاب شده',
        icon: <MergeIcon/>,
      },
      {
        func: () => editor.chain().focus().splitCell().run(),
        label: 'جداسازی انتخاب شده',
        icon: <SplitIcon/>,
      },
      {
        func: () => editor.chain().focus().toggleHeaderColumn().run(),
        label: 'هایلایت کردن ستون',
        icon: <HeaderColumnIcon/>,
      },
      {
        func: () => editor.chain().focus().toggleHeaderRow().run(),
        label: 'هایلایت کردن ردیف',
        icon: <HeaderRowIcon/>,
      },
      {
        func: () => editor.chain().focus().toggleHeaderCell().run(),
        label: 'هایلایت کردن سلول انتخاب شده',
        icon: <HeaderCellIcon/>,
      },
      {
        func: () => editor.chain().focus().deleteTable().run(),
        label: 'پاک کردن جدول',
        icon: <DeleteIcon/>,
      },
    ];

    const handleTableSelect = (option) => {
      option.func();
    };

    const handleColorChange = (color) => {
      setColor(color.hex);
      editor.chain().focus().setColor(color.hex).run();
    };

    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          colorPickerRef.current &&
          !colorPickerRef.current.contains(event.target)
        ) {
          setShowColorPicker(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [colorPickerRef]);

    const setLink = useCallback(() => {
      const previousUrl = editor.getAttributes('link').href;
      const url = window.prompt('URL', previousUrl);

      if (url === null) {
        return;
      }

      if (url === '') {
        editor.chain().focus().extendMarkRange('link').unsetLink().run();
        return;
      }

      editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({href: url})
        .run();
    }, [editor]);

    const setFontSize = (fontSize) => {
      editor.chain().focus().setMark('textStyle', {fontSize}).run();
    };

    const handleElementTagChange = (label) => {
      elementTag.forEach((element) => {
        if (element.label === label) {
          element.func();
        }
      });
    };

    if (!editor) {
      return null;
    }

    return (
      <nav className={'text-editor-top-bar'}>
        <CustomSelect
          Icon={SelectArrowIcon}
          options={elementTag}
          defaultValue={'مدل نوشته'}
          onChange={(e) => handleElementTagChange(e.target.value)}
        />
        <CustomDropdown
          options={dropDownOptions}
          onSelect={handleTableSelect}
        />
        <CustomSelect
          Icon={SelectArrowIcon}
          options={fontSizes}
          defaultValue={'سایز نوشته'}
          onChange={(e) => setFontSize(e.target.value)}
        />

        <button onClick={() => editor.chain().focus().toggleHighlight().run()}
                className={editor.isActive('highlight') ? 'is-active' : ''}>
          <PaintBrushIcon/>
        </button>
        <button onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                className={editor.isActive('bold') ? 'is-active' : ''}>
          <TextBoldIcon/>
        </button>

        <button onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                className={editor.isActive('italic') ? 'is-active' : ''}>
          <TextItalicIcon/>
        </button>

        <button onClick={() => editor.chain().focus().toggleStrike().run()}
                disabled={!editor.can().chain().focus().toggleStrike().run()}
                className={editor.isActive('strike') ? 'is-active' : ''}>
          <StrikeIcon/>
        </button>

        <button onClick={() => {
          editor.chain().focus().unsetAllMarks().run();
          editor.commands.clearNodes();
        }}>
          <EraserIcon/>
        </button>

        <button onClick={setLink}
                className={editor.isActive('link') ? 'is-active' : ''}>
          <LinkIcon/>
        </button>
        <button onClick={() => editor.chain().focus().unsetLink().run()}
                disabled={!editor.isActive('link')}>
          <UnLinkIcon/>
        </button>

        <button onClick={() => editor.chain().focus().addImage().run()}>
          <ImageIcon/>
        </button>

        <button
          onClick={() => editor.chain().focus().setHorizontalRule().run()}>
          <RulerIcon/>
        </button>

        <div className='color-picker-container' ref={colorPickerRef}>

          <button onClick={() => setShowColorPicker(!showColorPicker)}>
            <ColorPickerIcon/>
          </button>
          {showColorPicker && (
            <div className='color-picker'>
              <SketchPicker
                color={color}
                onChangeComplete={handleColorChange}
              />
            </div>
          )}
        </div>

        <button onClick={() => editor.chain().focus().toggleBulletList().run()}
                className={editor.isActive('bulletList') ? 'is-active' : ''}>
          <BulletListIcon/>
        </button>

        <button onClick={() => editor.chain().focus().toggleOrderedList().run()}
                className={editor.isActive('orderedList') ? 'is-active' : ''}>
          <NumberListIcon/>
        </button>

        <button onClick={() => editor.chain().focus().setTextAlign('right').run()}
                className={editor.isActive({textAlign: 'right'}) ? 'is-active' : ''}>
          <TextRightIcon/>
        </button>

        <button onClick={() => editor.chain().focus().setTextAlign('center').run()}
                className={editor.isActive({textAlign: 'center'}) ? 'is-active' : ''}>
          <TextCenterIcon/>
        </button>

        <button onClick={() => editor.chain().focus().setTextAlign('left').run()}
                className={editor.isActive({textAlign: 'left'}) ? 'is-active' : ''}>
          <TextLeftIcon/>
        </button>

        <button onClick={() => editor.chain().focus().setTextAlign('justify').run()}
                className={editor.isActive({textAlign: 'justify'}) ? 'is-active' : ''}>
          <TextJustifyIcon/>
        </button>

        <button onClick={() => editor.chain().focus().toggleCodeBlock().run()}
                className={editor.isActive('codeBlock') ? 'is-active' : ''}>
          <CodeIcon/>
        </button>

        <button onClick={() => editor.chain().focus().redo().run()}
                disabled={!editor.can().chain().focus().redo().run()}>
          <RedoIcon/>
        </button>

        <button onClick={() => editor.chain().focus().undo().run()}
                disabled={!editor.can().chain().focus().undo().run()}>
          <UndoIcon/>
        </button>
      </nav>
    );
  };

  let imagePath = [];

  const uploadFn = async (file) => {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('entity', fixEntity);
    return axios.post(prefixUrl() + "/memoPlusTemporaryUpload/?request=uploadFile", formData)
      .then((response) => {
        if (response.data.status === true) {
          imagePath.push({
            filePath: response.data.filePath,
            fileUrl: response.data.fileUrl,
          });
          return response.data.fileUrl;
        } else {
          console.log(response.data.message);
        }
      }).catch((e) => {
        throw e.response.data.error;
      });
  };

  const extensions = [
    UploadImage.configure({
      uploadFn: uploadFn,
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    Highlight,
    Table.configure({
      resizable: true,
    }),
    TableRow,
    TableHeader,
    CustomTableCell,
    Color.configure({types: [TextStyle.name, ListItem.name]}),
    CustomTextStyle,
    StarterKit.configure({
      bulletList: {
        keepMarks: true,
        keepAttributes: false,
      },
      orderedList: {
        keepMarks: true,
        keepAttributes: false,
      },
    }),
  ];

  function extractImagSrc(htmlString) {
    const imgRegex = /<img[^>]+src="([^">]+)"/g;
    let match;
    const scrAll = [];

    while ((match = imgRegex.exec(htmlString)) !== null) {
      scrAll.push(match[1]);
    }
    return scrAll;
  }

  const handleUpdate = (content) => {
    setContent(content);
    const urls = extractImagSrc(content);
    imagePath.forEach((item) => {
      let hasFound = false;
      urls.forEach((element) => {
        if (element === item.fileUrl) {
          hasFound = true;
        }
      });
      if (hasFound === false) {
        axios.delete(
          prefixUrl() + "/memoPlusTemporaryUpload" + '?request=deleteFile&filePath=' + item.filePath
        ).then((response) => {
          if (response.data.status === true) {
            imagePath = imagePath.filter(
              (deleteItem) =>
                deleteItem.fileUrl !== item.fileUrl
            );
          } else {
            console.log(response.data.message);
          }
        }).catch((e) => {
          throw e.response.data.error;
        });
      }
    });
  };

  const submitDataHandler = async () => {
    const obj = {entity: myLocation.state?.entity, pkValue: myLocation.state?.pkValue, editorData: content}
    const response = await _axios.post(prefixUrl() + "/memoPlusTemporaryUpload/?request=submitEditorData", obj)
    if (response.data.status) {
      toast.success(response.data?.message)
      navigateTo(-1)
    }
  }

  try {
    return (
      <main className={'ez-editor-main'}>
        {isLoad ?
          <>
            <EditorProvider
              slotBefore={<MenuBar/>}
              extensions={extensions}
              content={content}
              onUpdate={(editor) => handleUpdate(editor.editor.getHTML())}>
              {""}
            </EditorProvider>
            <div className={"button-div"}>
              <button onClick={submitDataHandler}>ثبت</button>
            </div>
          </> : <div className={"loader-div"}><Loader/></div>}
      </main>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default TextEditor;